<template>
    <v-navigation-drawer
        :value="visible"
        temporary
        touchless
        :right="!$vuetify.rtl"
        :width="$vuetify.breakpoint.smAndUp ? 550 : '100%'"
        @input="v=>{$emit('input', v)}"
        app>
        <v-card height="100%">
            <div class="drawer-header d-flex align-center mb-4">
                <span class="font-weight-semibold text-base text--primary">{{$t('inform.details.title')}}</span>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    small
                    @click="$emit('handleCancel')"
                    >
                    <v-icon size="22">
                        {{ icons.mdiClose }}
                    </v-icon>
                </v-btn>
            </div>

            <v-simple-table :class="$vuetify.theme.dark ? 'simple-table-box simple-table-dark':'simple-table-box'" dense>
                <template v-slot:default>
                    <tbody>
                        <tr v-for="(item, index) in userList" :key="index">
                            <td class="details-label-l">{{item.label}}</td>
                            <td>
                                <span class="text--secondary" v-if="item.type=='time'">{{ detailsList[item.key] ? moment(detailsList[item.key] * 1000).format('YYYY-MM-DD HH:mm:ss') : null }}</span>
                                <span class="text--secondary" v-else>{{ detailsList[item.key] }}</span>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
    </v-navigation-drawer>
</template>

<script>
import { noticeDetail } from "@/api/index";
import moment from 'moment';
import { mdiClose } from '@mdi/js'

export default {
    data() {
        return {
			userList: [
				{ key: 'title', label: this.$t('inform.details.list01')},
				{ key: 'publishTime', label: this.$t('inform.details.list02'), type: 'time'},
				{ key: 'readTime', label: this.$t('inform.details.list03'), type: 'time'},
				{ key: 'stateStr', label: this.$t('inform.details.list04')},
				{ key: 'content', label: this.$t('inform.details.list05')},
				{ key: 'managerName', label: this.$t('inform.details.list06')},
			],
            detailsList: [],
            icons: {
                mdiClose
            }
        };
    },
    props: {
        visible: Boolean,
        infoData: Object,
    },
    created() {
        this.getData()
    },
    methods: {
        moment,
        getData() {
            noticeDetail({
                id: this.infoData.id
            }).then(res=>{
                if(res.code == 200) {
                    this.detailsList = res.data
                    this.$emit("getDatass")
                }
            })
        },
        handleCancel() {
            this.$emit("handleCancel")
        }
    },
}
</script>

<style lang='scss' scoped>
    .limit_th_width ::v-deep {
        .ant-descriptions-item-label {
            white-space: nowrap;

        }
    }
    .ant-descriptions-bordered.ant-descriptions-small .ant-descriptions-item-content ::v-deep{
        white-space: normal;
        word-break: break-all;
    }
    ::v-deep{
        .v-data-table__wrapper{
            height: 100% !important;
        }
    }
    ::v-deep {
        .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td{
            white-space: normal !important;
        }
    }
    @media screen and (min-width: 320px) and (max-width: 480px){
        .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td{
			max-width: 229px !important;
		}
    }
</style>